var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 0.5V3H22L15.75 12.375V23H8.25V12.375L2 3H0.75V0.5H23.25ZM5.00462 3L10.75 11.618V20.5H13.25V11.618L18.9954 3H5.00462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutlined);
export default __webpack_public_path__ + "static/media/filter-outlined.2c5f62ce2226ad8b3f901725c2da83b9.svg";
export { ForwardRef as ReactComponent };